module.exports = __webpack_public_path__ + "static/img/logo2.fa9249a0.png";